import { useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useRoutes } from "react-router-dom";
import ThemeRoutes from "./routes/Router";
import { AuthProvider } from "./Context/AuthContext";
import Router from "./routes/Router";
import Header from "./layouts/Header";
import 'react-toastify/dist/ReactToastify.css';

const App = () => {


  return (
    <AuthProvider>
      <Header />
      <div className="dark">
        <main>
          <div className="pageWrapper d-lg-flex">
            <div className="contentArea">
              <Container className="p-4" fluid>
                <Router />
              </Container>
            </div>
          </div>
        </main>
      </div>
    </AuthProvider>
  );
};

export default App;
